import { Tir } from "./tir";
import { ControlPoint } from "./controlPoint";
import { ProprieteAffichee, CustomAffichage, TypePropriete } from "./proprieteAffichee";


export class Vibration  {
  id:number;
  tirId: number;
  siteId: number;
  tir: Tir;
  controlPointId: number;
  numeroPtControl: number;
  controlPoint: ControlPoint;
  picVibration: number;
  surpression: number;
  distance: number;


  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('numeroPtControl', 'CONTROL_POINT.NUMERO_PT_CONTROL', '', new CustomAffichage(TypePropriete.Number)));
    tab.push(new ProprieteAffichee('controlPoint', 'CONTROL_POINT.CONTROL_POINT', 'name'));
    tab.push(new ProprieteAffichee('distance', 'VIBRATION.DISTANCE', '', new CustomAffichage(TypePropriete.Number)));
    tab.push(new ProprieteAffichee('picVibration', 'VIBRATION.PIC', '', new CustomAffichage(TypePropriete.Number)));
    tab.push(new ProprieteAffichee('surpression', 'VIBRATION.SURPRESSION', '', new CustomAffichage(TypePropriete.Number)));
    return tab;
  }

 
}



export class VibrationLineChart {
  controlPointId: number;
  controlPointNumero: number;
  controlPointName: string;
  data: Array<{ t: Date, y: number }>;
}
